import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BasketProvider } from "@/context/BasketContext";
import { Toaster } from "@/components/ui/sonner";
import CookieConsent from "@/components/CookieConsent";
import Landing from "@/pages/Landing";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import RecipesPage from "@/pages/RecipesPage";
import RecipeDetailPage from "@/pages/RecipeDetailPage";
import BasketPage from "@/pages/BasketPage";
import TradePage from "@/pages/TradePage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import TraderDashboard from "@/pages/TraderDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center" data-testid="auth-loading">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-kera-copper">Loading</span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  if (user.role === "trader") return <Navigate to="/trade/dashboard" replace />;
  return children;
}

function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BasketProvider>
          <HelmetProvider>
          <BrowserRouter>
            <PageViewTracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:id" element={<ProductDetailPage />} />
              <Route path="/recipes" element={<RecipesPage />} />
              <Route path="/recipes/:id" element={<RecipeDetailPage />} />
              <Route path="/basket" element={<BasketPage />} />
              <Route path="/trade" element={<TradePage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/trade/dashboard" element={<TraderDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <RequireAuth>
                    <AdminDashboard />
                  </RequireAuth>
                }
              />
            </Routes>
          </BrowserRouter>
          </HelmetProvider>
          <Toaster position="top-center" richColors />
          <CookieConsent />
        </BasketProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
